import './UserBadge.scss';

import { MAIN_IMAGE_ROOT } from 'app_config';
import type { ReactNode } from 'react';

interface UserBadgeProps {
  colorPaletteColor?: string | null;
  profilePictureUrl?: string | null;
  initials?: string | null;
  name?: ReactNode;
  nameBadge?: boolean; // show name on colored background instead of profile picture or next to it
  hideName?: boolean; // only show profile picture or colored circle without name or nameBadge variant
}

const UserBadge = ({
  colorPaletteColor,
  profilePictureUrl,
  initials,
  name,
  nameBadge,
  hideName
}: UserBadgeProps) => {
  if (nameBadge) {
    return (
      <div className="UserBadge_wrapper">
        <div
          className="UserBadge_nameBadge"
          style={{
            backgroundColor: colorPaletteColor || undefined,
            borderColor: colorPaletteColor || undefined
          }}
        >
          {name}
        </div>
      </div>
    );
  }

  return (
    <div className="UserBadge_wrapper">
      <div
        className="UserBadge"
        style={{
          backgroundColor: colorPaletteColor || undefined,
          borderColor: colorPaletteColor || undefined,
          borderWidth: profilePictureUrl ? '2px' : '0px',
          backgroundImage: profilePictureUrl
            ? `url(${MAIN_IMAGE_ROOT}${profilePictureUrl})`
            : undefined
        }}
      >
        <div className={`UserBadge_text${initials && initials.length > 2 ? ' overflow' : ''}`}>
          {profilePictureUrl ? '' : initials}
        </div>
      </div>
      {name && !hideName && <div className="UserBadge_name">{name}</div>}
    </div>
  );
};

export default UserBadge;
